import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MonitorPlay, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@halalmart.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 relative overflow-hidden border-r border-border bg-secondary">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage:
              "url(https://images.unsplash.com/photo-1622597943118-45ebacc528d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="relative flex items-center gap-3">
          <img src="/logo.jpg" alt="Masjid Pintar" className="h-16 w-auto object-contain rounded-lg bg-white/70 p-1" />
        </div>
        <div className="relative">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Platform Digital Signage Masjid</p>
          <h1 className="font-display text-4xl xl:text-5xl font-bold leading-tight tracking-tight">
            Kelola semua layar masjid,<br />
            <span className="text-primary">secara real-time.</span>
          </h1>
          <p className="mt-6 text-muted-foreground max-w-md leading-relaxed">
            Atur playlist, jadwal kegiatan, dan tampilan TV Android di seluruh masjid dari satu pusat kendali.
          </p>
        </div>
        <div className="relative flex gap-6 text-sm text-muted-foreground">
          <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-accent" /> Sinkron real-time</span>
          <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-primary" /> Cache offline</span>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm animate-fade-up" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <img src="/logo.jpg" alt="Masjid Pintar" className="h-12 w-auto object-contain" />
          </div>
          <h2 className="font-display text-3xl font-bold tracking-tight">Masuk</h2>
          <p className="text-muted-foreground mt-2 mb-8">Akses dashboard signage Anda.</p>

          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-sm">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 h-12 bg-card border-border"
                placeholder="admin@halalmart.com"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm">Password</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 h-12 bg-card border-border"
                placeholder="••••••••"
                required
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-destructive">{error}</p>
            )}
            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-12 text-base font-semibold bg-primary hover:bg-primary/90 text-primary-foreground"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Masuk"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
